import { Provider } from './context';
import { Dialog } from './Dialog';

export function UserDetails(props) {
  return (
    <Provider {...props}>
      <Dialog />
    </Provider>
  );
}
